export default __webpack_public_path__ + "static/media/ELECTIVE__CS.f0870b53.png";